// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-class-section{
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px; /* Space between sections */
}

.normalize-section {
  margin-top: 12px;
  border: 1px solid #ccc;
  padding: 14px 16px;
  border-radius: 5px;
  background-color: #f9f9f9;
  width: calc(100% - 80px);
  max-width: 860px;
}

.normalize-section .step-and-instruction {
  margin: 0;
}

.normalize-section .title {
  background-color: #e2f3cf;
  padding: 8px 10px;
  text-align: left;
  margin: -14px -16px 12px -16px;
  border-radius: 5px 5px 0 0;
  font-size: 17px;
  width: 100vw;
}

.normalize-hint {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #495057;
}

.normalize-action-row {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.normalize-button {
  padding: 9px 20px;
  border: none;
  border-radius: 6px;
  background: #2f4fb5;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}

.normalize-button:hover {
  background: #1f3a8c;
  transform: translateY(-1px);
}

.normalize-button:disabled {
  background: #aab6ff;
  cursor: not-allowed;
  transform: none;
  opacity: 0.7;
}

.normalize-button--secondary {
  background: #f1f3f8;
  color: #2f4fb5;
  border: 1px solid #c7d2ef;
}

.normalize-button--secondary:hover {
  background: #e4eaf8;
}

.normalize-status {
  font-size: 13px;
}

.normalize-status--success {
  color: #1e7e34;
  font-weight: 600;
}

.normalize-status--info {
  color: #2f4fb5;
  font-weight: 600;
}

.normalize-summary {
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #dce7cf;
  background: #f7fbef;
  border-radius: 6px;
}

.normalize-summary__title {
  font-size: 13px;
  font-weight: 700;
  color: #2a4b15;
  margin-bottom: 6px;
}

.normalize-summary ul {
  margin: 0;
  padding-left: 18px;
}

.normalize-summary li {
  font-size: 12px;
  line-height: 1.45;
  color: #32431f;
  margin: 2px 0;
}

.normalize-lock-note {
  margin-top: 8px;
  font-size: 12px;
  color: #5d4b1f;
  background: #fff7e6;
  border: 1px solid #f5ddb1;
  border-radius: 6px;
  padding: 8px 10px;
}

.step-three-content {
  display: flex;
  width: 100%;
  gap: 24px;
  align-items: stretch;
  margin-top: 10px;
}

.uploaded-file-selector {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 220px;
  max-width: 260px;
}

.uploaded-file-selector h3 {
  margin: 0 0 6px 0;
  font-size: 15px;
  color: #2b365a;
  font-weight: 600;
}


.uploaded-file-button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 35px 12px 46px;
  border: 1px solid #d7e2ff;
  border-radius: 8px;
  background: #f4f7ff;
  color: #1c2b61;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-align: left;
  position: relative;
  width: auto;
  min-width: 200px;
  max-width: 100%;
  word-break: break-word;
}

.uploaded-file-button__checkbox {
  position: absolute;
  top: 12px;
  left: 14px;
  display: flex;
  align-items: center;
}

.uploaded-file-button__checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #2f4fb5;
}

.uploaded-file-button__checkbox input[type="checkbox"]:disabled {
  cursor: not-allowed;
  accent-color: #cccccc;
}

.uploaded-file-button:hover {
  background: #e6edff;
  border-color: #b7c8ff;
  transform: translateY(-1px);
}

.uploaded-file-button.is-active {
  border-color: #2f4fb5;
  background: #e3eaff;
  box-shadow: 0 4px 12px rgba(47, 79, 181, 0.15);
}

.uploaded-file-button.is-disabled {
  background: #f2f2f2;
  border-color: #dddddd;
  color: #888888;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.uploaded-file-button.is-disabled:hover {
  transform: none;
}

.uploaded-file-button.is-configured .uploaded-file-button__status {
  background: #2ecc71;
}

.uploaded-file-button.is-excluded {
  background: #f5f6fb;
  border-style: dashed;
  border-color: #c8d2f6;
  color: #6b779e;
  opacity: 0.85;
}

.uploaded-file-button.is-excluded:hover {
  background: #eef1fb;
  border-color: #b5c1f1;
  transform: none;
}

.uploaded-file-button__name {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.3;
}

.uploaded-file-button__meta {
  font-size: 12px;
  color: #5a6aa6;
}

.uploaded-file-button__status {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #aab6ff;
}

.uploaded-file-button__status--error {
  background: #e74c3c;
  color: #ffffff;
  width: auto;
  height: auto;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
}

.uploaded-file-button.is-excluded .uploaded-file-button__status {
  background: #c7cff4;
}

.uploaded-file-button__meta--excluded {
  color: #b65913;
  font-weight: 600;
}

/* Container for sample column and search button */
.sample-column-section {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
}

/* Change dropdown container layout */
.dropdown-container {
  margin: 20px 0;
  display: flex;
  flex-direction: column; /* Arrange as column */
  gap: 20px; /* Space between elements */
  width: 100%;
}

/* New row for side-by-side dropdowns */
.dropdowns-row {
  display: flex;
  flex-direction: row;
  gap: 30px; /* Space between two dropdowns */
  justify-content: flex-start; /* Align dropdowns to left */

}

/* Update search button container */
.search-button-container {
  margin-top: 18px; /* Align with dropdown */
  display: flex;
  justify-content: flex-start;
}

  
/* Fixed width for column dropdown boxes */
.column-dropdowns {
  width: 350px; /* Fixed width */
  min-width: 350px; /* Minimum width */
  flex-shrink: 0; /* Prevent shrinking */
}



.dropdown-with-search {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

/* Keep search button text on a single line */
.search-column-button {
  background-color: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 4px;
  padding: 10px 5px; /* Reduced left/right padding */
  font-size: 16px;
  color: #1976D2;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  width: 400px;
  max-width: 400px;
  height: 41px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  margin-left: 40px;
  white-space: nowrap; /* Keep text on one line */
  overflow: hidden; /* Hide overflowed text */
  text-overflow: ellipsis; /* Show ... for overflowed text */
}


.search-column-button:hover {
  background-color: #bbdefb;
  border-color: #64b5f6;
  color: #1565C0;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transform: translateY(-1px);
}

.search-column-button:active {
  background-color: #90caf9;
  transform: translateY(0);
}

/* Fix label alignment */
.column-dropdowns label {
  font-weight: bold;
  color: #333;
  margin-left: 0; /* Changed from 40px to 0 for left alignment */
  white-space: nowrap;
  display: block;
  font-size: 15px;
  padding-left: 40px; /* Use padding instead of margin */
}


/* Increase width for selected column message for better visibility */
.info-message-step3 {
  margin-top: 10px;
  margin-left: 40px;
  margin-right: 40px;
  padding: 10px;
  background-color: #f4f4f9;
  border-left: 5px solid #4caf50;
  color: #0c5460;
  font-size: 15px;
  border-radius: 5px;
  white-space: normal; /* Use normal instead of nowrap */
  width: 300px; /* Fixed width */
  overflow-wrap: break-word; /* Line break for long words */
}

.column-selection-area {
  display: flex;
  gap: 40px; /* Space between Patient Group and Sample ID blocks */
  padding: 20px 40px; /* Add padding around the selection blocks */
  background-color: #f8f9fa; /* Light background like step 6 */
  border-radius: 8px;
  margin-top: 20px;
  border: 1px solid #e9ecef;
  width: fit-content;
  max-width: 100%;
}

.column-select-block {
  display: flex;
  flex-direction: column;
  gap: 10px; /* Space between label, display, and button */
}

.column-select-block label {
  font-weight: bold;
  color: #333;
  font-size: 15px;
  margin-bottom: 5px; /* Space below label */
}

.selected-column-display {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  min-height: 40px; /* Ensure it has some height */
  display: flex;
  align-items: center;
  width: 300px; /* Match dropdown width */
  box-sizing: border-box;
}

.selected-column-display .placeholder {
  color: #999;
  font-style: italic;
}

.select-column-button {
  /* Use general button styles or define specific ones */
  padding: 10px 15px;
  font-size: 1rem;
  background-color: #007bff; /* Example primary color */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 300px; /* Match display width */
  box-sizing: border-box;
}

.select-column-button:hover {
  background-color: #0056b3;
}

.select-column-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* Removed margin to align dropdowns from the same start */
#illnessColumnDropdown, #sampleColumnDropdown {
  width: 300px;
  max-width: 300px;
  padding: 10px;
  margin-left: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  color: #555;
  background-color: #fff;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

#illnessColumnDropdown:focus {
  border-color: #4caf50;
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
  outline: none;
}

/* Option styling */
#illnessColumnDropdown option {
  font-size: 16px;
  padding: 8px;
}


#sampleColumnDropdown:focus {
    border-color: #4caf50;
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
    outline: none;
}

/* Option styling */
#sampleColumnDropdown option {
    font-size: 16px;
    padding: 8px;
}

.merge-action-panel {
  margin-top: 20px;
  padding: 18px 24px;
  border: 1px solid #d7e2ff;
  border-radius: 10px;
  background: #eef3ff;
  display: flex;
  gap: 24px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.merge-action-copy {
  flex: 1 1 260px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #1c2b61;
}

.merge-action-copy h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.merge-action-copy p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.merge-action-controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.merge-files-button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background: #2f4fb5;
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.merge-files-button:hover {
  background: #1f3a8c;
  transform: translateY(-1px);
}

.merge-files-button:disabled {
  background: #aab6ff;
  cursor: not-allowed;
  transform: none;
  opacity: 0.7;
}

.merge-status {
  font-size: 13px;
  color: #3d4c77;
}

.merge-status--progress {
  color: #bd6b00;
}

.merge-status--success {
  color: #1e7e34;
}

.merge-hint {
  font-size: 13px;
  color: #5a6aa6;
  margin: 0;
}


.merge-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  color: #1c2b61;
}

.merge-summary__label {
  font-weight: 600;
}

.merge-summary__value {
  font-weight: 500;
}

/* ─── Step 4.5 — Resampling distribution table ─────────────────────────── */
.resampling-dist-table-wrapper {
  margin-bottom: 14px;
}

.resampling-imbalance-warning {
  font-size: 13px;
  color: #7a4f00;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 5px;
  padding: 7px 10px;
  margin: 0 0 10px 0;
}

.resampling-dist-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-bottom: 8px;
}

.resampling-dist-table th {
  background: #eef1f8;
  color: #2f4fb5;
  font-weight: 600;
  padding: 7px 10px;
  text-align: left;
  border-bottom: 2px solid #c7d2ef;
}

.resampling-dist-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.resampling-row-minority td {
  background: #fff9f0;
}

.resampling-row-majority td {
  background: #f4faf0;
}

.resampling-dist-table tr:last-child td {
  border-bottom: none;
}

.resampling-synthetic-badge {
  display: inline-block;
  background: #fff3cd;
  color: #7a4f00;
  border: 1px solid #ffe082;
  border-radius: 4px;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: 500;
}

.resampling-majority-badge {
  display: inline-block;
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: 500;
}

.resampling-table-note {
  font-size: 11.5px;
  color: #6c757d;
  margin: 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/css/step3-getColumn.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ,EAAE,2BAA2B;AACvC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,aAAa;EACb,sBAAsB,EAAE,sBAAsB;EAC9C,SAAS,EAAE,2BAA2B;EACtC,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,gCAAgC;EAC3C,2BAA2B,EAAE,4BAA4B;;AAE3D;;AAEA,mCAAmC;AACnC;EACE,gBAAgB,EAAE,wBAAwB;EAC1C,aAAa;EACb,2BAA2B;AAC7B;;;AAGA,0CAA0C;AAC1C;EACE,YAAY,EAAE,gBAAgB;EAC9B,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,sBAAsB;AACxC;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB,EAAE,+BAA+B;EAClD,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB,EAAE,0BAA0B;EAC/C,gBAAgB,EAAE,yBAAyB;EAC3C,uBAAuB,EAAE,iCAAiC;AAC5D;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc,EAAE,8CAA8C;EAC9D,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB,EAAE,kCAAkC;AACxD;;;AAGA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAE,iCAAiC;EACtD,YAAY,EAAE,gBAAgB;EAC9B,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,qDAAqD;EAChE,kBAAkB,EAAE,4CAA4C;EAChE,yBAAyB,EAAE,iCAAiC;EAC5D,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,6CAA6C;AAC1D;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB,EAAE,8BAA8B;EAChD,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAE,yBAAyB;EACvC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAE,0BAA0B;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,YAAY,EAAE,wBAAwB;EACtC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,YAAY;AACd;;;AAGA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB","sourcesContent":[".select-class-section{\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 5px; /* Space between sections */\n}\n\n.normalize-section {\n  margin-top: 12px;\n  border: 1px solid #ccc;\n  padding: 14px 16px;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  width: calc(100% - 80px);\n  max-width: 860px;\n}\n\n.normalize-section .step-and-instruction {\n  margin: 0;\n}\n\n.normalize-section .title {\n  background-color: #e2f3cf;\n  padding: 8px 10px;\n  text-align: left;\n  margin: -14px -16px 12px -16px;\n  border-radius: 5px 5px 0 0;\n  font-size: 17px;\n  width: 100vw;\n}\n\n.normalize-hint {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  color: #495057;\n}\n\n.normalize-action-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.normalize-button {\n  padding: 9px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #2f4fb5;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.2s;\n}\n\n.normalize-button:hover {\n  background: #1f3a8c;\n  transform: translateY(-1px);\n}\n\n.normalize-button:disabled {\n  background: #aab6ff;\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.7;\n}\n\n.normalize-button--secondary {\n  background: #f1f3f8;\n  color: #2f4fb5;\n  border: 1px solid #c7d2ef;\n}\n\n.normalize-button--secondary:hover {\n  background: #e4eaf8;\n}\n\n.normalize-status {\n  font-size: 13px;\n}\n\n.normalize-status--success {\n  color: #1e7e34;\n  font-weight: 600;\n}\n\n.normalize-status--info {\n  color: #2f4fb5;\n  font-weight: 600;\n}\n\n.normalize-summary {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border: 1px solid #dce7cf;\n  background: #f7fbef;\n  border-radius: 6px;\n}\n\n.normalize-summary__title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #2a4b15;\n  margin-bottom: 6px;\n}\n\n.normalize-summary ul {\n  margin: 0;\n  padding-left: 18px;\n}\n\n.normalize-summary li {\n  font-size: 12px;\n  line-height: 1.45;\n  color: #32431f;\n  margin: 2px 0;\n}\n\n.normalize-lock-note {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #5d4b1f;\n  background: #fff7e6;\n  border: 1px solid #f5ddb1;\n  border-radius: 6px;\n  padding: 8px 10px;\n}\n\n.step-three-content {\n  display: flex;\n  width: 100%;\n  gap: 24px;\n  align-items: stretch;\n  margin-top: 10px;\n}\n\n.uploaded-file-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 220px;\n  max-width: 260px;\n}\n\n.uploaded-file-selector h3 {\n  margin: 0 0 6px 0;\n  font-size: 15px;\n  color: #2b365a;\n  font-weight: 600;\n}\n\n\n.uploaded-file-button {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 12px 35px 12px 46px;\n  border: 1px solid #d7e2ff;\n  border-radius: 8px;\n  background: #f4f7ff;\n  color: #1c2b61;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  text-align: left;\n  position: relative;\n  width: auto;\n  min-width: 200px;\n  max-width: 100%;\n  word-break: break-word;\n}\n\n.uploaded-file-button__checkbox {\n  position: absolute;\n  top: 12px;\n  left: 14px;\n  display: flex;\n  align-items: center;\n}\n\n.uploaded-file-button__checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #2f4fb5;\n}\n\n.uploaded-file-button__checkbox input[type=\"checkbox\"]:disabled {\n  cursor: not-allowed;\n  accent-color: #cccccc;\n}\n\n.uploaded-file-button:hover {\n  background: #e6edff;\n  border-color: #b7c8ff;\n  transform: translateY(-1px);\n}\n\n.uploaded-file-button.is-active {\n  border-color: #2f4fb5;\n  background: #e3eaff;\n  box-shadow: 0 4px 12px rgba(47, 79, 181, 0.15);\n}\n\n.uploaded-file-button.is-disabled {\n  background: #f2f2f2;\n  border-color: #dddddd;\n  color: #888888;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.uploaded-file-button.is-disabled:hover {\n  transform: none;\n}\n\n.uploaded-file-button.is-configured .uploaded-file-button__status {\n  background: #2ecc71;\n}\n\n.uploaded-file-button.is-excluded {\n  background: #f5f6fb;\n  border-style: dashed;\n  border-color: #c8d2f6;\n  color: #6b779e;\n  opacity: 0.85;\n}\n\n.uploaded-file-button.is-excluded:hover {\n  background: #eef1fb;\n  border-color: #b5c1f1;\n  transform: none;\n}\n\n.uploaded-file-button__name {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.3;\n}\n\n.uploaded-file-button__meta {\n  font-size: 12px;\n  color: #5a6aa6;\n}\n\n.uploaded-file-button__status {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #aab6ff;\n}\n\n.uploaded-file-button__status--error {\n  background: #e74c3c;\n  color: #ffffff;\n  width: auto;\n  height: auto;\n  padding: 2px 6px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.uploaded-file-button.is-excluded .uploaded-file-button__status {\n  background: #c7cff4;\n}\n\n.uploaded-file-button__meta--excluded {\n  color: #b65913;\n  font-weight: 600;\n}\n\n/* Container for sample column and search button */\n.sample-column-section {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n/* Change dropdown container layout */\n.dropdown-container {\n  margin: 20px 0;\n  display: flex;\n  flex-direction: column; /* Arrange as column */\n  gap: 20px; /* Space between elements */\n  width: 100%;\n}\n\n/* New row for side-by-side dropdowns */\n.dropdowns-row {\n  display: flex;\n  flex-direction: row;\n  gap: 30px; /* Space between two dropdowns */\n  justify-content: flex-start; /* Align dropdowns to left */\n\n}\n\n/* Update search button container */\n.search-button-container {\n  margin-top: 18px; /* Align with dropdown */\n  display: flex;\n  justify-content: flex-start;\n}\n\n  \n/* Fixed width for column dropdown boxes */\n.column-dropdowns {\n  width: 350px; /* Fixed width */\n  min-width: 350px; /* Minimum width */\n  flex-shrink: 0; /* Prevent shrinking */\n}\n\n\n\n.dropdown-with-search {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n/* Keep search button text on a single line */\n.search-column-button {\n  background-color: #e3f2fd;\n  border: 1px solid #90caf9;\n  border-radius: 4px;\n  padding: 10px 5px; /* Reduced left/right padding */\n  font-size: 16px;\n  color: #1976D2;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  width: 400px;\n  max-width: 400px;\n  height: 41px;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  margin-left: 40px;\n  white-space: nowrap; /* Keep text on one line */\n  overflow: hidden; /* Hide overflowed text */\n  text-overflow: ellipsis; /* Show ... for overflowed text */\n}\n\n\n.search-column-button:hover {\n  background-color: #bbdefb;\n  border-color: #64b5f6;\n  color: #1565C0;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  transform: translateY(-1px);\n}\n\n.search-column-button:active {\n  background-color: #90caf9;\n  transform: translateY(0);\n}\n\n/* Fix label alignment */\n.column-dropdowns label {\n  font-weight: bold;\n  color: #333;\n  margin-left: 0; /* Changed from 40px to 0 for left alignment */\n  white-space: nowrap;\n  display: block;\n  font-size: 15px;\n  padding-left: 40px; /* Use padding instead of margin */\n}\n\n\n/* Increase width for selected column message for better visibility */\n.info-message-step3 {\n  margin-top: 10px;\n  margin-left: 40px;\n  margin-right: 40px;\n  padding: 10px;\n  background-color: #f4f4f9;\n  border-left: 5px solid #4caf50;\n  color: #0c5460;\n  font-size: 15px;\n  border-radius: 5px;\n  white-space: normal; /* Use normal instead of nowrap */\n  width: 300px; /* Fixed width */\n  overflow-wrap: break-word; /* Line break for long words */\n}\n\n.column-selection-area {\n  display: flex;\n  gap: 40px; /* Space between Patient Group and Sample ID blocks */\n  padding: 20px 40px; /* Add padding around the selection blocks */\n  background-color: #f8f9fa; /* Light background like step 6 */\n  border-radius: 8px;\n  margin-top: 20px;\n  border: 1px solid #e9ecef;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.column-select-block {\n  display: flex;\n  flex-direction: column;\n  gap: 10px; /* Space between label, display, and button */\n}\n\n.column-select-block label {\n  font-weight: bold;\n  color: #333;\n  font-size: 15px;\n  margin-bottom: 5px; /* Space below label */\n}\n\n.selected-column-display {\n  padding: 10px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  min-height: 40px; /* Ensure it has some height */\n  display: flex;\n  align-items: center;\n  width: 300px; /* Match dropdown width */\n  box-sizing: border-box;\n}\n\n.selected-column-display .placeholder {\n  color: #999;\n  font-style: italic;\n}\n\n.select-column-button {\n  /* Use general button styles or define specific ones */\n  padding: 10px 15px;\n  font-size: 1rem;\n  background-color: #007bff; /* Example primary color */\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  width: 300px; /* Match display width */\n  box-sizing: border-box;\n}\n\n.select-column-button:hover {\n  background-color: #0056b3;\n}\n\n.select-column-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n/* Removed margin to align dropdowns from the same start */\n#illnessColumnDropdown, #sampleColumnDropdown {\n  width: 300px;\n  max-width: 300px;\n  padding: 10px;\n  margin-left: 40px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  color: #555;\n  background-color: #fff;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n#illnessColumnDropdown:focus {\n  border-color: #4caf50;\n  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);\n  outline: none;\n}\n\n/* Option styling */\n#illnessColumnDropdown option {\n  font-size: 16px;\n  padding: 8px;\n}\n\n\n#sampleColumnDropdown:focus {\n    border-color: #4caf50;\n    box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);\n    outline: none;\n}\n\n/* Option styling */\n#sampleColumnDropdown option {\n    font-size: 16px;\n    padding: 8px;\n}\n\n.merge-action-panel {\n  margin-top: 20px;\n  padding: 18px 24px;\n  border: 1px solid #d7e2ff;\n  border-radius: 10px;\n  background: #eef3ff;\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.merge-action-copy {\n  flex: 1 1 260px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  color: #1c2b61;\n}\n\n.merge-action-copy h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.merge-action-copy p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.merge-action-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.merge-files-button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #2f4fb5;\n  color: #ffffff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease-in-out, transform 0.2s ease-in-out;\n}\n\n.merge-files-button:hover {\n  background: #1f3a8c;\n  transform: translateY(-1px);\n}\n\n.merge-files-button:disabled {\n  background: #aab6ff;\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.7;\n}\n\n.merge-status {\n  font-size: 13px;\n  color: #3d4c77;\n}\n\n.merge-status--progress {\n  color: #bd6b00;\n}\n\n.merge-status--success {\n  color: #1e7e34;\n}\n\n.merge-hint {\n  font-size: 13px;\n  color: #5a6aa6;\n  margin: 0;\n}\n\n\n.merge-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 13px;\n  color: #1c2b61;\n}\n\n.merge-summary__label {\n  font-weight: 600;\n}\n\n.merge-summary__value {\n  font-weight: 500;\n}\n\n/* ─── Step 4.5 — Resampling distribution table ─────────────────────────── */\n.resampling-dist-table-wrapper {\n  margin-bottom: 14px;\n}\n\n.resampling-imbalance-warning {\n  font-size: 13px;\n  color: #7a4f00;\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  border-radius: 5px;\n  padding: 7px 10px;\n  margin: 0 0 10px 0;\n}\n\n.resampling-dist-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.resampling-dist-table th {\n  background: #eef1f8;\n  color: #2f4fb5;\n  font-weight: 600;\n  padding: 7px 10px;\n  text-align: left;\n  border-bottom: 2px solid #c7d2ef;\n}\n\n.resampling-dist-table td {\n  padding: 6px 10px;\n  border-bottom: 1px solid #e9ecef;\n  vertical-align: middle;\n}\n\n.resampling-row-minority td {\n  background: #fff9f0;\n}\n\n.resampling-row-majority td {\n  background: #f4faf0;\n}\n\n.resampling-dist-table tr:last-child td {\n  border-bottom: none;\n}\n\n.resampling-synthetic-badge {\n  display: inline-block;\n  background: #fff3cd;\n  color: #7a4f00;\n  border: 1px solid #ffe082;\n  border-radius: 4px;\n  padding: 2px 7px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.resampling-majority-badge {\n  display: inline-block;\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 2px 7px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.resampling-table-note {\n  font-size: 11.5px;\n  color: #6c757d;\n  margin: 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
